import { Icon, ModalCloseButton } from '@chakra-ui/react';
import { InDesktop } from '@ui/components/MobileOrDesktop';
import {
  ModalOrDragDrawerContent,
  ModalOrDrawer,
  ModalOrDrawerCloseButton,
  ModalOrDrawerHeader,
  ModalOrDrawerOverlay,
} from '@ui/components/ModalOrDrawer';
import { useTranslations } from '@ui/i18n';
import { ArrowBack } from '@veno-app/icons';

import HarvestAllOverview from './HarvestAllOverview';
import HarvestGarden from './HarvestGarden';
import { HarvestAllStep, useHarvestAllDrawer } from './useHarvestAllDrawer';

export const HarvestAllDrawer = () => {
  const isOpen = useHarvestAllDrawer((s) => s.isOpen);
  const step = useHarvestAllDrawer((s) => s.step);
  const onClose = useHarvestAllDrawer((s) => s.onClose);
  const t = useTranslations();

  return (
    <>
      <ModalOrDrawer
        placement="bottom"
        scrollBehavior="inside"
        isOpen={isOpen}
        onClose={onClose}
        size={{
          base: 'full',
          desktop: 'md',
        }}
      >
        <ModalOrDrawerOverlay />
        <ModalOrDragDrawerContent>
          <InDesktop>
            <ModalCloseButton />
          </InDesktop>
          {step > 0 && (
            <ModalOrDrawerCloseButton
              left="10px"
              onClick={(e) => {
                useHarvestAllDrawer.setState({
                  step: step - 1,
                  error: { code: '', message: '' },
                  isTransactionPending: false,
                });
                e.preventDefault();
              }}
            >
              <Icon as={ArrowBack} boxSize="16px" />
            </ModalOrDrawerCloseButton>
          )}
          <ModalOrDrawerHeader>{t('Harvest all')}</ModalOrDrawerHeader>
          {step === HarvestAllStep.LIST && <HarvestAllOverview />}
          {step === HarvestAllStep.HARVEST_GARDEN && <HarvestGarden />}
        </ModalOrDragDrawerContent>
      </ModalOrDrawer>
    </>
  );
};
